import { ReactElement, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import { Box, Text } from "@chakra-ui/react";

import Loader from "src/assets/images/splash_screen_loader.json";

import useLocalStorage from "src/hooks/useLocalstorage";

import Api from "src/Config";

type Props = {
  children: ReactElement;
};

const PrivateRoute = ({ children }: Props) => {
  const location = useLocation();
  const param = new URLSearchParams(location.search);
  const [storedAccess, setStoredAccess] = useLocalStorage("clu", {});
  const [, setStoredOrg] = useLocalStorage("clo", {});

  const host = window.location.origin;

  const [isLoad, setIsLoad] = useState(true);

  const refParam = param.get("session");
  const tokenRefParam = param.get("token");
  const login_with = param.get("login_with") || "dd";

  useEffect(() => {
    if (
      Object.entries(storedAccess).length === 0 &&
      !refParam &&
      !tokenRefParam
    ) {
      // const path =
      //   host === `https://radardemo.prembly.com`
      //     ? `https://radardemo.prembly.com/login`
      //     : `${process.env.REACT_APP_MAIN_URL}?loggedOut=true&&fromProd=${window?.location?.origin}`;

      const isWithRadar = localStorage.getItem("login-with");
      let path = "";
      if (isWithRadar === "radar") {
        console.log("User logged in with radar enabled");
        path =
          host === `https://radardemo.prembly.com`
            ? `${window?.location?.origin}/login`
            : `${window?.location?.origin}/login`;
      } else if (isWithRadar === "dd") {
        window.location.href = "https://app.prembly.com";
      } else {
        path =
          host === `https://radardemo.prembly.com`
            ? `https://radardemo.prembly.com/login`
            : `${window?.location?.origin}/login`;
      }
      window.location.replace(`${path}`);
    } else {
      setIsLoad(false);
    }
  }, [storedAccess]);

  const { isLoading, error } = useQuery({
    queryKey: ["sso_session", refParam],
    enabled: !!refParam,
    queryFn: async () => {
      // localStorage.clear();
      const {
        data: { data },
      } = await Api.get(`account/sso?session_id=${refParam}`);

      if (data) {
        setIsLoad(false);
        if (data.data.tenant) {
          const { AccessToken, TokenType, organisations, tenant } = data.data;

          const tenantLogo =
            tenant?.products?.find(
              (tenant: any) => tenant.code === "IDENTITYRADAR",
            )?.logo || "https://radar-backoffice.prembly.com/";

          const tenantSDK =
            tenant?.products?.find(
              (tenant: any) => tenant.code === "IDENTITYRADAR",
            )?.sdk_url || "";

          setStoredAccess({
            AccessToken,
            TokenType,
            org: organisations[0].organisation.id,
            tid: tenant.id, // tid means, tenant id
            tlogo: tenantLogo,
            tname:
              tenant?.products?.find(
                (product: any) => product.code === "IDENTITYRADAR",
              )?.name || "Identityradar",
            host:
              host === `https://radardemo.prembly.com`
                ? `https://radardemo.prembly.com`
                : tenant?.host,
            sdk: tenantSDK,
            tbrand: tenant.logo,
            isStartedTourGuide: false,
          });
          localStorage.setItem("login-with", "main");
          setStoredOrg({
            organisations: organisations,
          });
          return data;
        } else {
          window.location.replace(process.env.REACT_APP_MAIN_URL);
        }
      }
    },
  });

  const { isLoading: isTokenLoading, error: tokenError } = useQuery({
    queryKey: ["token_validation", tokenRefParam],
    enabled: !!tokenRefParam,
    queryFn: async () => {
      // localStorage.clear();
      const {
        data: { data },
      } = await Api.get(`account/token?token=${tokenRefParam}&version2=true`);
      console.log(data);
      if (data) {
        setIsLoad(false);
        if (data.tenant) {
          const { AccessToken, TokenType, organisation, tenant } = data;

          const tenantLogo = "https://radar-backoffice.prembly.com/";

          const tenantSDK = "https://radar-backoffice.prembly.com";

          const accessToStore = {
            AccessToken,
            TokenType,
            org: organisation[0].organisation.id,
            tid: tenant.id, // tid means, tenant id
            tlogo: tenantLogo,
            tname: "Identityradar",
            host:
              host === `https://radardemo.prembly.com`
                ? `https://radardemo.prembly.com`
                : tenant?.host,
            sdk: tenantSDK,
            tbrand: tenant.logo,
            isStartedTourGuide: false,
          };
          setStoredAccess(accessToStore);
          // set it in local sorage
          localStorage.setItem("clu", JSON.stringify(accessToStore));
          localStorage.setItem("login-with", login_with);

          setStoredOrg({
            organisations: organisation,
          });
          return data;
        } else {
          window.location.replace(process.env.REACT_APP_MAIN_URL);
        }
      }
    },
  });

  if (isLoad || isLoading || isTokenLoading) {
    return (
      <Box
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        height={"100vh"}
        position={"fixed"}
        width={"100%"}
        margin={"0px auto"}
        zIndex={9999999}
        background={"white"}
      >
        <Player
          src={Loader}
          style={{ width: "100px" }}
          className="player"
          loop
          autoplay
        />
        <Text>Please wait while we perform our charm!</Text>
      </Box>
    );
  }

  console.log("refParam:", refParam);
  console.log("tokenRefParam:", tokenRefParam);
  console.log("error:", error);
  console.log("tokenError:", tokenError);
  // CHECK IF TOKEN error OR TOKEN PARAM AND TOKEN ERROR IS TRUE
  if ((refParam && error) || (tokenRefParam && tokenError)) {
    const isWithRadar = localStorage.getItem("login-with");
    let path = "";
    if (isWithRadar === "radar") {
      console.log("User logged in with radar enabled");
      path =
        host === `https://radardemo.prembly.com`
          ? `${window?.location?.origin}/login`
          : `${window?.location?.origin}/login`;
    } else if (isWithRadar === "dd") {
      window.location.href = "https://app.prembly.com";
    } else {
      path =
        host === `https://radardemo.prembly.com`
          ? `https://radardemo.prembly.com/login`
          : `${window?.location?.origin}/login`;
    }

    localStorage.clear();
    console.log(path);
    // window.location.replace(`${path}`);
  } else {
    return children;
  }
};

export default PrivateRoute;
